import { z } from "zod";
/**
 * What the cellar's owner makes of a producer.
 *
 * A judgement about a house, not about a bottle and not about a wine — those
 * are a TastingNote and a WineRating respectively, and the three must not be
 * confused. Unknown is the default and the honest starting point: a producer
 * created by registering a wine has not been judged yet, and an absent opinion
 * must never read as a poor one.
 */
export const producerStandingSchema = z.enum(["Renowned", "Good", "Poor", "Unknown"]);
export const producerSummarySchema = z.object({
    id: z.string(),
    name: z.string(),
    standing: producerStandingSchema,
    /** How many wines in this cellar are theirs. */
    uses: z.number().int(),
});
export const producerListResponseSchema = z.object({
    producers: z.array(producerSummarySchema),
});
export const updateProducerRequestSchema = z.object({
    standing: producerStandingSchema,
});
//# sourceMappingURL=producer.js.map